import {Box, Typography} from '@viptech/react-components'
import Progressbar from 'src/components/Progressbar'
import SlideTypography from 'src/components/SlideTypography'
import usePersonalizedThemeByCompany from 'src/hooks/usePersonalizedThemeByCompany'
import {FaceDetection} from 'src/services/api'
import {formatDateTime} from 'src/utilities/datetimeUtils'
import PhotoCard from './PhotoCard'

interface Props {
  onClick: (faceDetection: FaceDetection) => void
  faceDetection: FaceDetection
  isSelected: boolean
  isPersonUnknown?: boolean
}

export function HistoryPhotoFrame({onClick, isSelected, faceDetection, isPersonUnknown}: Props) {
  const {styledTheme} = usePersonalizedThemeByCompany()
  return (
    <>
      <Box
        width='fit-content'
        height='fit-content'
        padding='8px'
        border={isSelected ? '1px solid #D0D5DD' : ''}
        backgroundColor={isSelected ? `${styledTheme.advancedFilter.backgroundColor}` : '#F2F4F7'}
        onClick={() => onClick(faceDetection)}
        style={{cursor: 'pointer', outline: isSelected ? `1px solid ${styledTheme.colors.primary}` : '', outlineOffset: '4px'}}>
        <Box width='128px' display='flex' rowGap='8px' direction='column'>
          <PhotoCard
            width='128px'
            height='136px'
            src={`${process.env.REACT_APP_CROPPED_IMAGES_BASE_URL}/${faceDetection.cropImageKey}`}
            style={{cursor: 'pointer'}}
          />

          <Box>
            <SlideTypography
              variant='label'
              size='12px'
              weight={isSelected ? 700 : 600}
              color={isSelected ? styledTheme.faceRecognition.titleColor : '#667085'}>
              {faceDetection.face?.name ?? 'DESCONHECIDO'}
            </SlideTypography>
            {!isPersonUnknown && <Progressbar fontSize='10px' percentage={Math.round(faceDetection.accuracy * 100)} height='6px' />}
            <Box display='flex' justify='space-between'>
              <Typography variant='label' size='12px' weight={isSelected ? 500 : 400} color={isSelected ? '#344054' : '#667085'}>
                {formatDateTime(faceDetection.createdAt).formattedDate}
              </Typography>
              <Typography variant='label' size='12px' weight={isSelected ? 500 : 400} color={isSelected ? '#344054' : '#667085'}>
                {formatDateTime(faceDetection.createdAt).formattedTime}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  )
}
